import PaymentPlanCard from './PaymentPlanCard'

export default PaymentPlanCard
